import { render, staticRenderFns } from "./InboxConversationItem.vue?vue&type=template&id=c3bdc2da&scoped=true"
import script from "./InboxConversationItem.vue?vue&type=script&lang=ts"
export * from "./InboxConversationItem.vue?vue&type=script&lang=ts"
import style0 from "./InboxConversationItem.vue?vue&type=style&index=0&id=c3bdc2da&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bdc2da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3bdc2da')) {
      api.createRecord('c3bdc2da', component.options)
    } else {
      api.reload('c3bdc2da', component.options)
    }
    module.hot.accept("./InboxConversationItem.vue?vue&type=template&id=c3bdc2da&scoped=true", function () {
      api.rerender('c3bdc2da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxConversationItem.vue"
export default component.exports